import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import EstimateBuilderHeader from '../EstimateBuilderHeaderConnector';
import EstimateCard from '../EstimateCard/EstimateCardConnector';
import SuccessToast from '../SuccessToastConnector';
import config from '../../helpers/config';
import sendAnalyticsEvent from './sendAnalyticsEvent';

const EstimateBuilder = ({ selectedDesignId, getDCSignature }) => {
  useEffect(() => {
    window.localStorage.removeItem('estimateMode');
    const { designModeCookieDomain } = window.pageContextJavascript;
    const cookieSettings = { domain: designModeCookieDomain || undefined, sameSite: 'none', secure: true };
    Cookies.remove('designMode', cookieSettings);
    if (config.repId) {
      getDCSignature();
    }
    sendAnalyticsEvent();
  });

  return (
    <div className="container estimateContainer">
      <SuccessToast />
      <EstimateBuilderHeader />
      {selectedDesignId && <EstimateCard selectedDesignId={selectedDesignId} />}
    </div>
  );
};

EstimateBuilder.propTypes = {
  getDCSignature: PropTypes.func.isRequired,
  selectedDesignId: PropTypes.string,
};
EstimateBuilder.defaultProps = {
  selectedDesignId: null,
};
export default EstimateBuilder;

